/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

import './DeleteConfirmationModal.scss'

const DeleteConfirmationModal = ({ id, close, kill, success, clicked }) => {
  const { t } = useTranslation()

  return (
    <div id='DeleteConfirmationModal'>
      <i
        className={`top-icon fa fa-${success ? 'bomb' : 'times-circle'}`}
        aria-hidden='true'
        style={{ color: success ? 'black' : 'red' }}
      />
      <p>
        {success
          ? t('leads.deleteModal.successMessage')
          : t('leads.deleteModal.confirmMessage')}
      </p>

      {success ? (
        <button className='close-modal' onClick={close}>
          {t('common.close')}
        </button>
      ) : (
        <div className='button-area'>
          <button className='never-mind' onClick={close}>
            {t('leads.deleteModal.neverMind')}
          </button>
          <button className='kill' onClick={() => kill(id)} disabled={clicked}>
            {clicked ? (
              <i className='fa fa-spinner fa-spin' aria-hidden='true' />
            ) : (
              t('leads.deleteModal.killIt')
            )}
          </button>
        </div>
      )}
    </div>
  )
}

export default DeleteConfirmationModal
